import { errorHandler } from '../utils/utils';
import axios from 'axios';
import { loginClear, userProfileDetails } from '../redux/reducer/authReducer'

const ADMIN_SERVICE = process.env.REACT_APP_ADMIN_SERVICE

export const getUserProfile = async ({ token, dispatch }) => {
    const res = await axios.get(`${ADMIN_SERVICE}/Account/GetProfile`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    if (res.data?.statusCode === 401) {
        localStorage.removeItem("auth-user");
        dispatch(loginClear());
    } else {
        dispatch(userProfileDetails(res.data?.data))
    }
}


export const updateProfie = async ({ token, data }) => {
    try {
        const res = await axios.post(`${ADMIN_SERVICE}/Account/UpdateProfile`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (err) {
        errorHandler(err, data, `${ADMIN_SERVICE}/Account/UpdateProfile`)
        return err;
    }
}

export const changePassword = async ({ token, data }) => {
    try {
        const res = await axios.post(`${ADMIN_SERVICE}/Account/ChangePassword`, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return res
    } catch (err) {
        errorHandler(err, data, `${ADMIN_SERVICE}/Account/ChangePassword`)
        return err;
    }
}


export const getAuditProfile = async ({
    token, dispatch
}) => {
    try {
        const res = await axios.get(`${ADMIN_SERVICE}/AuditUsers/GetAuditUserProfile`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return res.data
    } catch (err) {

    }
}

export const updateAuditPassword = async ({ token, data }) => {
    try {
        const res = await axios.post(`${ADMIN_SERVICE}/AuditUsers/UpdateMasterPassword?password=${data.password}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        return res;
    } catch (err) {
        errorHandler(err, data, `${ADMIN_SERVICE}/AuditUsers/UpdateMasterPassword?password=${data.password}`)
    }
}